/*
Crashsight的加载模块
安卓： libCrashSight.so、libCrashSightPlugin.so
iOS ：CrashSight、CrashSightCore、CrashSightAdapter、CrashSightPlugin
鸿蒙：libCrashSight.so
windows：CrashSight64.dll
linux：libCrashSight.so
 */
const crashSightModuleSet = new Set([
  'libCrashSight.so',
  'libCrashSightPlugin.so',
  'CrashSight',
  'CrashSightCore',
  'CrashSightAdapter',
  'CrashSightPlugin',
  'libCrashSight.so',
  'CrashSight64.dll',
]);

export const CrashModuleUtil = Object.freeze({
  /**
   * @param soName {string}
   * @param lowerSystemSoNameList {string[]}
   * @param lowerAppSoNameList {string[]}
   * */
  getIsSystemModule(soName, lowerSystemSoNameList, lowerAppSoNameList) {
    const lowerSoName = (soName || '').toLowerCase();
    if (lowerAppSoNameList && lowerAppSoNameList.length > 0) {
      return !lowerAppSoNameList.includes(lowerSoName);
    } else {
      return lowerSystemSoNameList.includes(lowerSoName);
    }
  },

  /**
   * 是否是CrashSight模块
   * */
  getIsCrashSightModule(soName) {
    return crashSightModuleSet.has(soName);
  },
});
